import { render, staticRenderFns } from "./MarksEntryCell.vue?vue&type=template&id=48ae4fd9&"
import script from "./MarksEntryCell.vue?vue&type=script&lang=js&"
export * from "./MarksEntryCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports